import cx from 'clsx';
import * as React from 'react';

import { TableDealerResults } from '../../../types/gameTypes';
import { QuicksilverTileOutfitType } from '../types';
import styles from './LiveTableResults.module.scss';

const RESULT_WIDTH = 24 + 2 * 4;
const WRAPPER_PADDING = 2 * 4;

interface LiveTableResultsProps {
  results: TableDealerResults[];
  outfit: QuicksilverTileOutfitType;
  tileWidth?: number;
}

const LiveTableResults = ({
  results,
  outfit,
  tileWidth = 320,
}: LiveTableResultsProps) => {
  const amount = Math.floor((tileWidth - WRAPPER_PADDING) / RESULT_WIDTH);

  return (
    <div className={cx(styles.container)}>
      {results
        .slice(0, Math.min(amount, outfit === 'big' ? 5 : 8))
        .map((result, i) => (
          <div className={styles.resultWrapper} key={i}>
            {result.tooltip && outfit === 'banner' && (
              <div className={styles.tooltip}>
                <span>{result.tooltip}</span>
              </div>
            )}
            <div
              className={cx(
                styles.result,
                styles[(result.color || '').replace('-', '_')]
              )}
            >
              <p className={styles.value}>{result.value}</p>
            </div>
          </div>
        ))}
    </div>
  );
};

export default React.memo(LiveTableResults);
